import React, { useEffect, useState, useCallback } from 'react'
import { Main, Access } from './ModalTabs'
import Modal from '../../components/Modal'
import Confirmation from '../../components/Confirmation/Confirmation'
import { methodOffice } from '../../assets/const'
import { useFormik } from 'formik'
import { MethodOfficeContext } from '../../utils/context'
import { createFolder, updateFolder } from '../../actions/methodOffice'
import { useDispatch, useSelector } from 'react-redux'
import { createNotification } from '../../components/Notifications/Notifications'


export default function ModalComponent({ data, closeModal, file, onFolderCreated }) {

  const dispatch = useDispatch()
  const [mode, setMode] = useState('main')

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])
  const { loading } = useSelector(state => state.method_office)

  const isEditMode = !!data?.mrid

  const onSubmit = () => {
    formik.handleSubmit()
  }

  const formik = useFormik({
    initialValues: isEditMode ? data : {},
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: console.log

  })

  const createFolderModal = async () => {
    try {
      if (isEditMode) {
        await dispatch(updateFolder(data.mrid, data.mr_parent, formik.values))
        createNotification('success', 'Папка успешно обновлена')
      } else {
        await dispatch(createFolder(file?.mrid, formik.values))
        createNotification('success', 'Папка успешно создана')
      }
      formik.resetForm()
      closeModal(true)
      if (onFolderCreated) {
        setTimeout(() => {
          onFolderCreated()
        }, 500)
      }
    } catch (error) {
      createNotification('error', isEditMode ? 'Ошибка обновления папки' : 'Ошибка создания папки')
      console.error('Error saving folder:', error)
      closeModal(false)
    }
  }

  const renderTab = () => {
    switch (mode) {
      case 'main': return <Main />
      case 'access': return <Access />
      default: return
    }
  }

  return (
    <MethodOfficeContext.Provider value={{
      closeModal,
      onSubmit,
      formik,
      data,
      addMode: !data?.lid,
      file,
      createFolderModal
    }}>
      <Modal
        open={!!data}
        menuItem={mode}
        setMenuItem={setMode}
        menuList={methodOffice}
        onClose={handleClose}
        closeOnOverlayClick={true}
        closeOnEsc={true}
      >
        {renderTab()}
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </Modal>
    </MethodOfficeContext.Provider>
  )
}